import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBatteryFull,
    faBatteryQuarter,
    faBatteryThreeQuarters
} from "@fortawesome/free-solid-svg-icons";

const getBatteryIcon = (condition) => {
    // 3.63 yellow
    // 4,22 green
    // 3,57 red
    let className = "";
    let icon = null;
    if (condition && condition.voltage) {
        const { voltage } = condition;
        if (Number(voltage) > 3.63 && Number(voltage) <= 4.22) {
            className = "text-success";
            icon = faBatteryFull;
        } else if (Number(voltage) > 3.57 && Number(voltage) <= 3.63) {
            className = "text-warning";
            icon = faBatteryThreeQuarters;
        } else if (Number(voltage) <= 3.57) {
            className = "text-danger";
            icon = faBatteryQuarter;
        }

        if (icon) {
            return (
                <FontAwesomeIcon
                    icon={icon}
                    className={className}
                />
            );
        }
    }
    return false;
};

export default getBatteryIcon;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-battery-icon.js